__turbopack_context__.v({
  "buySection": "Ji1dXq_buySection",
  "chargerLearnMoreModal": "Ji1dXq_chargerLearnMoreModal",
  "disclaimerButton": "Ji1dXq_disclaimerButton",
  "disclaimerButtonContainer": "Ji1dXq_disclaimerButtonContainer",
  "heightOpacityIn": "Ji1dXq_heightOpacityIn",
  "largePrompt": "Ji1dXq_largePrompt",
  "learnMoreButton": "Ji1dXq_learnMoreButton",
  "leftPanel": "Ji1dXq_leftPanel",
  "mobileCarouselSection": "Ji1dXq_mobileCarouselSection",
  "notServicableMessageContainer": "Ji1dXq_notServicableMessageContainer",
  "powerPlugSubsection": "Ji1dXq_powerPlugSubsection",
  "priceContentContainer": "Ji1dXq_priceContentContainer",
  "rightPanel": "Ji1dXq_rightPanel",
  "root": "Ji1dXq_root",
  "section": "Ji1dXq_section",
  "separator": "Ji1dXq_separator",
  "sizeInfoModal": "Ji1dXq_sizeInfoModal",
  "stickyPanel": "Ji1dXq_stickyPanel",
});
